var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dropdownIsOpened)?_c('tr',[_c('td',{attrs:{"colspan":_vm.columnsCount}},[(_vm.renderDropdown)?_c('div',{staticClass:"m-table-row-dropdown-wrapper__content"},[_vm._t("default",null,{"active":_vm.dropdownIsOpened,"tableRow":_vm.tableRow})],2):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }